import { render, staticRenderFns } from "./PoiHubList.vue?vue&type=template&id=9a398f0a"
import script from "./PoiHubList.vue?vue&type=script&lang=js"
export * from "./PoiHubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports